import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";


//Internal Imports
import { useForm } from "../../../contexts/form";
import { IFormAnswerDetail, IFormAnswerDetailOption } from "../../../interfaces/IAnswer";
import { IQuestion } from "../../../interfaces/IQuestion";
import { ISurvey } from "../../../interfaces/ISurvey";
import { InsertFormAnswered } from "../../../services/survey";
import { COLORS } from "../../constants/colors";
import { LoadingIcon } from "../../constants/cssElements";
import { getError, openNotification, tryCatch } from "../../constants/Utilities";
import { PreguntaTipo } from "../../enums/AllEnums";
import OutLineButton from "../OutLineButton/OutLineButton";
import TypeInputGeneratorItem from "../TypeInputGeneratorItem/TypeInputGeneratorItem";
import Modal from '../../../common/components/Modal/Modal';
import LoadingButton from "../LoadingButton/LoadingButton";
import { IFormQuestionOption } from "../../../interfaces/IForm";
import { createTrue } from "typescript";


interface IProp {
    active: boolean;
    method?: () => void;
    borderColor: string;
    textColor: string;
    backgroundcolorheader?: string;
    backgroundcolorbody?: string;
    placeholdercolor?: string;
    opacity?: number;
    item: ISurvey;
    setRegistrado: React.Dispatch<React.SetStateAction<boolean>>;
}
const ContainerBox = styled.div<any>`
    color: ${(props) => props.textColor} !important;
    opacity: ${(props) => !!props.opacity ? props.opacity : 1};
    display: grid;
    grid-template-rows: 1fr 3fr auto;
    margin: 2% 1.5% 2% 0%;
    height: 70vh;
    
    .ContainerBox-header{
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        
    }
    .ContainerBox-header h1{
       color:  ${COLORS.black_text_color1};
       font-weight: bold;
    }
    .ContainerBox-header h2{
        color:  ${COLORS.blue_main(1)};
        font-weight: bold;
    }
    .ContainerBox-body{
        display: grid;
        grid-template-columns: 0.3fr 3fr 0.3fr;

    }
    .ContainerBox-body-left{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: xx-large;
        color: ${COLORS.blue_third};
        cursor: pointer;
        transition: transform .3s;
        
    }
    .ContainerBox-body-middle{
        display: grid;
        grid-template-rows: 3fr 0.01fr 1fr;
        gap: 20px;
    }
    .ContainerBox-body-right{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: xx-large;
        color: ${COLORS.blue_third};
        cursor: pointer;
       
    }
    .ContainerBox-body-right i{
        transition: transform .3s;
    }
    .ContainerBox-body-left i{
        transition: transform .3s;
    }
    .ContainerBox-body-right i:hover{
        transform: scale(1.3);
    }
    .ContainerBox-body-left i:hover{
        transform: scale(1.3);
    }
    .ContainerBox-footer{
        display: flexbox !important;
        flex-direction: column !important;
        text-align: center !important;
        -webkit-box-pack: center !important;
        -webkit-justify-content: center !important;
        -ms-flex-pack: center !important;
        justify-content: center !important;
        font-size: x-large;
        color: ${COLORS.blue_third};
        height: 100%;
        width: 100%;
        //background-color: red;
        top: 0px;
        bottom: 0px;
    }

    .ContainerBox-body-middle-error{
        color: ${COLORS.red_error2};
    }
    
       /* ${props => props.active && (`
        cursor: pointer;
        
        :active {
            opacity: 0.7;
        }

        :hover {
            box-shadow: 1px 1.5px 4px 1px ${COLORS.black_text_color3};
            //transform: scale(1.01);
        }

    `)} */
`;


const SecuentialSurveyItem: React.FC<IProp> = ({ active, backgroundcolorheader, backgroundcolorbody, method, borderColor, textColor, opacity, item, setRegistrado }) => {
    const [question, SetQuestion] = useState<IQuestion>();
    const [isNextAble, SetIsNextAble] = useState<boolean>(true);
    const [IsBackAble, SetIsBackAble] = useState<boolean>(true);
    const [answerValue, SetAnswerValue] = useState<any>('');
    const [isLastQuestion, SetIsLastQuestion] = useState<boolean>(false);
    const { optionSelected, setOptionSelected, setFormAnswer, formAnswer } = useForm()
    const [orderQuestion, setOrdenQuestion] = useState<number[]>([]);
    const [validation, setValidation] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const workQuestion = () => {
        const consultarIsPregunta = formAnswer?.respuesta.find((pregunta) => pregunta.preguntaID === question?.preguntaID);

        // console.log(formAnswer?.respuesta.find((pregunta)=>pregunta.preguntaID===question?.preguntaID)?.preguntaID,"Pregunta a Validar");
        if (consultarIsPregunta === undefined) {
            asignQuestion()
        } else {
            actuzalizarQuestion()
        }
    }
    const actuzalizarQuestion = () => {
        const newList = formAnswer?.respuesta.map((pregunta) => {
            const _respuestaOpcion: IFormAnswerDetailOption[] = [{
                respuestaDetalleID: 0,
                respuestaOpcionID: optionSelected?.respuestaOpcionID!,
                respuesta: !!answerValue ? answerValue : null,
                resultado: optionSelected?.resultado!
            }];

            if (pregunta.preguntaID === question?.preguntaID) {
                const actualziarPreg: IFormAnswerDetail = {
                    ...pregunta, respuestaOpcion: _respuestaOpcion
                }
                return actualziarPreg;
            }
            return pregunta;
        })

        setFormAnswer({
            ...formAnswer!,
            sistemaOrigen: "BisFormularioWeb",
            respuesta: newList!
        });
        SetAnswerValue('');

        const index = orderQuestion.find(x => x === question?.preguntaID!)
        if (index === undefined) {
            const oldArr = orderQuestion;
            oldArr.push(question?.preguntaID!);
        }

    }
    const asignQuestion = () => {

        const listrespuesta = formAnswer?.respuesta;
        const answerDetail: IFormAnswerDetail = {
            respuestaDetalleID: 0,
            respuestaID: 0,
            grupoPreguntaID: question?.grupoPreguntaID!,
            preguntaID: question?.preguntaID!,
            grupo: question?.grupoPreguntaNombre!,
            grupoOrden: question?.grupoPreguntaOrden!,
            pregunta: question?.preguntas!,
            preguntaTipo: question?.preguntaTipo!,
            preguntaTipoNombre: question?.preguntaTipoNombre!,
            preguntaOrden: question?.orden!,
            respuestaOpcion: [
                {
                    respuestaDetalleID: 0,
                    respuestaOpcionID: optionSelected?.respuestaOpcionID!,
                    respuesta: !!answerValue ? answerValue : null,
                    resultado: optionSelected?.resultado!
                }
            ]
        }

        listrespuesta?.push(answerDetail);
        setFormAnswer({
            ...formAnswer!,
            sistemaOrigen: "BisFormularioWeb",
            respuesta: listrespuesta!
        });
        isLastQuestion ? SetAnswerValue(answerValue) : SetAnswerValue(''); // si es la ultima pregunta no resetear el valor


        const oldArr = orderQuestion;
        oldArr.push(question?.preguntaID!);
        setOrdenQuestion(oldArr);

    }

    const handleBackQuestion = () => {

        const indexQuestion: number[] = orderQuestion.filter(item => item !== question?.preguntaID!)
        setOrdenQuestion(indexQuestion);

        if (item.pregunta.find(question => question.esPrincipal) != null) {
            SetIsNextAble(true)
            SetIsLastQuestion(false)
            const questionToSet = item.pregunta.find(nextId => nextId.respuestaOpcion.find(resp => resp.preguntaSiguienteID! === question?.preguntaID));
            if (questionToSet?.esPrincipal) {
                SetIsBackAble(false)
            }
            SetQuestion(questionToSet)
        } else {
            SetIsNextAble(false)
        }
    }

    const handleNextQuestion = () => {
        SetIsBackAble(true);
        if (optionSelected?.preguntaSiguienteID != null || optionSelected?.preguntaSiguienteID != undefined) {
            if (question?.preguntaID === optionSelected.preguntaSiguienteID) {
                if (item.pregunta.find(nextId => nextId.preguntaID === question?.respuestaOpcion.find(x => x.preguntaSiguienteID != null)?.preguntaSiguienteID) === undefined) {
                    SetIsNextAble(false);
                    SetIsLastQuestion(true);
                    workQuestion();

                } else {
                    workQuestion();
                    SetQuestion(item.pregunta.find(nextId => nextId.preguntaID === question.respuestaOpcion.find(x => x.preguntaSiguienteID != null)?.preguntaSiguienteID));

                }
            } else {
                var preg = item.pregunta.find(nextId => nextId.preguntaID === optionSelected.preguntaSiguienteID);
                if (preg != null || preg != undefined)
                {
                    workQuestion();
                    SetQuestion(preg);
                }
                else
                {
                    openNotification('error', 'Próxima pregunta', 'La próxima pregunta no está configurada correctamente, contacte con el equipo BIS. ');
                }
            }
        } else {

            SetIsNextAble(true);
            workQuestion();
            SetQuestion(item.pregunta.find(nextId => nextId.preguntaID === question?.respuestaOpcion.find(x => x.preguntaSiguienteID != null)?.preguntaSiguienteID))

        }
    }

    const toOrderAnswer = () => {

        const listAnswer: IFormAnswerDetail[] = [];
        orderQuestion.map(preguntaID => {

            const pregunta: IFormAnswerDetail = formAnswer?.respuesta.find(itemPreg => itemPreg.preguntaID === preguntaID)!;

            if (pregunta.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple) {
                const listaRespuestaSelect: IFormQuestionOption[] = item.pregunta.find(x => x.preguntaID == pregunta.preguntaID)?.respuestaOpcion.map(y => y)!;
                const repuestaOptItem: IFormAnswerDetailOption[] = [];
                const repuestaOpt: IFormAnswerDetailOption = pregunta.respuestaOpcion[0];
                if (repuestaOpt.respuesta != null && repuestaOpt.respuesta != "")
                {
                    repuestaOpt.respuesta?.split("|").map(valor => {
                        var opcion = listaRespuestaSelect.find(item => item.respuesta == valor);
                        const _respuestaOpcion: IFormAnswerDetailOption = {
                            respuestaDetalleID: 0,
                            respuestaOpcionID: opcion?.respuestaOpcionID!,
                            respuesta: valor,
                            resultado: opcion?.resultado!,
                        };
                        repuestaOptItem.push(_respuestaOpcion);
                    });
                }
                else 
                {
                    const _respuestaOpcion: IFormAnswerDetailOption = {
                        respuestaDetalleID: 0,
                        respuestaOpcionID: null,
                        respuesta: null,
                        resultado: null
                    };
                    repuestaOptItem.push(_respuestaOpcion);
                }
                
                pregunta.respuestaOpcion = repuestaOptItem;

            } else if (pregunta.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) {
                const repuestaOptItem: IFormAnswerDetailOption[] = [];

                if (pregunta.respuestaOpcion[0]?.respuesta != null && pregunta.respuestaOpcion[0]?.respuesta != "")
                {
                    pregunta.respuestaOpcion[0]?.respuesta?.split("|").map(valor => {
                        const _respuestaOpcion: IFormAnswerDetailOption = {
                            respuestaDetalleID: 0,
                            respuestaOpcionID: pregunta.respuestaOpcion[0]?.respuestaOpcionID!,
                            respuesta: valor,
                            resultado: pregunta.respuestaOpcion[0]?.resultado!,
                        };
                        repuestaOptItem.push(_respuestaOpcion);
                    });
                }
                else
                {
                    const _respuestaOpcion: IFormAnswerDetailOption = {
                        respuestaDetalleID: 0,
                        respuestaOpcionID: pregunta.respuestaOpcion[0]?.respuestaOpcionID!,
                        respuesta: null,
                        resultado: pregunta.respuestaOpcion[0]?.resultado!,
                    };
                    repuestaOptItem.push(_respuestaOpcion);
                }

                pregunta.respuestaOpcion = repuestaOptItem;

            }

            listAnswer.push(pregunta);

        });

        setFormAnswer({
            respuestaID: formAnswer?.respuestaID as number,
            sistemaOrigen: "BisFormularioWeb",
            formularioID: formAnswer?.formularioID as number,
            formularioListadoDetalleID: formAnswer?.formularioListadoDetalleID!,
            respuesta: [],
            usuarioLatitud: null,
            usuarioLongitud: null,
        });
    }
    const onSubmit = () => {
        const consultarIsPregunta = formAnswer?.respuesta.find((pregunta) => pregunta.preguntaID === question?.preguntaID);
        if (consultarIsPregunta === undefined) {
            asignQuestion()
        } else {
            actuzalizarQuestion()
        }
        toOrderAnswer();
        saveAnswer();
    }
    const saveAnswer = () => {
        tryCatch(() => {
            setFormLoading(true);
            InsertFormAnswered(formAnswer!)
                .then((response) => {
                    // deberia llevar un modal
                    openNotification('success', 'Guardar', response.msg!);
                    setRegistrado(true);
                    //navigate(`/bisformulario/encuesta`);

                    //
                })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => setFormLoading(false));
        })


    }


    useEffect(() => {
        SetQuestion(item.pregunta.find(quest => quest.esPrincipal === true));
        SetIsBackAble(false);
    }, [item]);

    useEffect(() => {
        SetIsNextAble(false);
        SetIsLastQuestion(false);

        const pregunta = formAnswer?.respuesta.find(pregunta => pregunta.preguntaID === question?.preguntaID);
        const value = pregunta?.respuestaOpcion.find(x => x.respuesta)?.respuesta?.toString();
        value === undefined ? SetAnswerValue('') : SetAnswerValue(value);

        if (question?.preguntaTipoNombre !== PreguntaTipo.Seleccion) {
            const opcionRespuesta: IFormQuestionOption | undefined = question?.respuestaOpcion.find(x => x);
            if(opcionRespuesta != null) {
                setOptionSelected(opcionRespuesta);
                opcionRespuesta.preguntaSiguienteID === null ? SetIsLastQuestion(true) : SetIsNextAble(true);
            }
        }
        else
        {
            const opcionRespuesta: IFormQuestionOption | undefined = question?.respuestaOpcion.find(x => x.respuesta === value);
            if(opcionRespuesta != null) {
                setOptionSelected(opcionRespuesta);
                opcionRespuesta.preguntaSiguienteID === null ? SetIsLastQuestion(true) : SetIsNextAble(true);
            }
        }
    }, [question]);

    useEffect(() => {
        if (question?.esObligatoria && (answerValue === "" || answerValue === undefined || answerValue === null)) {
            setValidation("Requerido");
        }
        else if (answerValue != "" && answerValue != undefined && answerValue != null) {
           
            if (question?.preguntaTipoNombre === PreguntaTipo.Numerico) {
                if (question?.valorMinimo !== null && question?.valorMinimo! > parseInt(answerValue)) {
                    setValidation("El minimo es " + (question?.valorMinimo!));
                }
                else if (question?.valorMaximo !== null && question?.valorMaximo! < parseInt(answerValue)) {
                    setValidation("El máximo es " + (question?.valorMaximo!));
                } else {
                    setValidation("")
                }
            } else if (question?.preguntaTipoNombre === PreguntaTipo.Fecha || question?.preguntaTipoNombre === PreguntaTipo.FechaRango || question?.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) {
                const dateMin: Date = new Date(question?.valorMinimo!);
                const dateMax: Date = new Date(question?.valorMaximo!);
                const fecha: Date = new Date(answerValue);
                if (question?.valorMinimo !== null && dateMin > new Date(fecha.setDate(fecha.getDate() + 1))) {
                    setValidation("El minimo es " + (question?.valorMinimo!));
                } else if (question?.valorMaximo !== null && dateMax < new Date(fecha.setHours(0,0,0,0))){
                    setValidation("El máximo es " + (question?.valorMaximo!));
                } else if(question?.valorMinimo == null && question?.valorMaximo !== null && dateMax < new Date(fecha.setDate(fecha.getDate() + 1))){
                    setValidation("El máximo es " + (question?.valorMaximo!));  
                }
                else {
                    setValidation("")
                }
            } else if(question?.preguntaTipoNombre === PreguntaTipo.FechaHora){
                const dateMin: Date = new Date(question?.valorMinimo!);
                const dateMax: Date = new Date(question?.valorMaximo!);
                const fecha: Date = new Date(answerValue);
                if(question?.valorMinimo !==null && dateMin > fecha){
                    setValidation("El minimo es " + (question?.valorMinimo!));
                } else if (question?.valorMaximo !==null && dateMax < fecha) {
                    setValidation("El maximo es " + (question?.valorMaximo!));
                }
                else{
                    setValidation("")
                }
            } else if(question?.preguntaTipoNombre === PreguntaTipo.Hora){
                const valorMin: Date = new Date(question?.valorMinimo!);
                const valorMax: Date = new Date(question?.valorMaximo!);
                const horaMin = valorMin.toLocaleTimeString('en-UK')
                const horaMax = valorMax.toLocaleTimeString('en-UK')
                if(question?.valorMinimo!== null && answerValue < horaMin){
                    setValidation("El minimo es " + (horaMin))
                } else if(question?.valorMaximo!== null && answerValue > horaMax){
                    setValidation("El maximo es " + (horaMax))
                } else{
                    setValidation("")
                }
            } else if (question?.preguntaTipoNombre === PreguntaTipo.Archivo) {
                try {
                    const parsedValue = JSON.parse(answerValue)
                    const fileType = parsedValue.type;
                    const isExcelOrPdf  =
                        fileType === 'application/vnd.ms-excel' ||
                        fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                        fileType === 'application/pdf';
    
                    if (!isExcelOrPdf) {
                        setValidation("Solo se permiten archivos Excel o PDF.");
                    } else{
                        setValidation("")
                    }
                } catch (e) {
                    setValidation("Solo se permiten archivos Excel o PDF.");
                }
            } else if (question?.preguntaTipoNombre === PreguntaTipo.Galeria || question?.preguntaTipoNombre === PreguntaTipo.CamaraGaleria || question?.preguntaTipoNombre === PreguntaTipo.Imagen) {
                try {
                    const parsedValue = JSON.parse(answerValue)
                    const fileType = parsedValue.type;
                    const isImage  =
                        fileType === 'image/jpeg' ||
                        fileType === 'image/png' ||
                        fileType === 'image/gif';
    
                    if (!isImage) {
                        setValidation("Solo se permiten archivos de imagen (JPEG, PNG, GIF).");
                    } else{
                        setValidation("")
                    }
                } catch (e) {
                    setValidation("Solo se permiten archivos de imagen (JPEG, PNG, GIF).");
                }
            }
            else {
                setValidation("")
            }                
        }
        else {
            setValidation("")
        }
    });

    useEffect(() => {
        if (validation.length > 0) {
            SetIsNextAble(false)
            SetIsLastQuestion(false);
            setError(true);
        } else {
            setError(false);
            if (question?.preguntaTipoNombre !== PreguntaTipo.Seleccion) {
                SetIsNextAble(false);
                SetIsLastQuestion(false);
                if (question?.respuestaOpcion[0].preguntaSiguienteID === null) {
                    SetIsLastQuestion(true)
                }
                else
                {
                    SetIsNextAble(true)
                }
            }
        }
    }, [validation, answerValue]);

    useEffect(() => {
        if (question?.preguntaTipoNombre === PreguntaTipo.Seleccion) {
            SetIsNextAble(false);
            SetIsLastQuestion(false);
            if (optionSelected?.preguntaSiguienteID === null) {
                SetIsLastQuestion(true);
            }
            else
            {
                SetIsNextAble(true);
            }   
        }
    }, [optionSelected]);
    
    return (
        <ContainerBox
            borderColor={borderColor}
            textColor={active === true ? textColor : COLORS.white_color1}
            opacity={opacity}
            active={active}
            backgroundcolorheader={active === true ? backgroundcolorheader : COLORS.black_text_color1}
            backgroundcolorbody={active === true ? backgroundcolorbody : COLORS.black_text_color1}
            onClick={!!active ? method : null}>
            <div className="ContainerBox-header">

                <h1>{question?.grupoPreguntaNombre}</h1>
                <h2>{question?.preguntas}</h2>
            </div>

            <div className="ContainerBox-body">
                <div className="ContainerBox-body-left" style={{ visibility: IsBackAble ? 'visible' : 'hidden' }} onClick={() => handleBackQuestion()}>
                    <i className="fa-solid fa-angle-left "></i>
                </div>
                <div className="ContainerBox-body-middle">
                    <TypeInputGeneratorItem active={false} value={question?.preguntaTipoNombre} OnChange={null} item={question!} SetAnswerValue={SetAnswerValue} answerValue={answerValue} setActive={SetIsNextAble} setIsLastQuestion={SetIsLastQuestion} isDraggable={true} />
                    {error ? <p className="ContainerBox-body-middle-error">{validation}</p> : <></>}
                    <div className="ContainerBox-footer" style={{ visibility: isLastQuestion === true ? 'visible' : 'hidden'}}>
                        <LoadingButton
                            disabled={error}
                            type="button"
                            title={"Enviar respuesta"}
                            style={{ height: '50px', width: '350px' }}
                            background={COLORS.blue_active}
                            color={COLORS.white_color1}
                            loading={formLoading.toString()}
                            method={() => onSubmit()}
                            fontsize={18}
                        />

                    </div>
                </div>
                <div className="ContainerBox-body-right" 
                style={{ 
                    visibility: isNextAble === true? 'visible' : 'hidden' }} 
                    onClick={() => isNextAble ? handleNextQuestion() : null}>
                    <i className="fa-solid fa-angle-right " ></i>
                </div>
            </div>
        </ContainerBox>
    )
}

export default SecuentialSurveyItem;